import bippath from "bip32-path";
export function bip32asBuffer(path) {
    var paths = !path ? [] : bippath.fromString(path).toPathArray();
    var buffer = Buffer.alloc(1 + paths.length * 4);
    buffer[0] = paths.length;
    paths.forEach(function (element, index) {
        buffer.writeUInt32BE(element, 1 + 4 * index);
    });
    return buffer;
}
//# sourceMappingURL=bip32.js.map